// extracted by mini-css-extract-plugin
export default {"notice":"CanvasSessionNotice_notice__4MCZk"};